$(() => {
  const convertMS = (ms) => {
    let hours, minutes, seconds
    seconds = Math.floor(ms / 1000)
    minutes = Math.floor(seconds / 60)
    seconds %= 60
    hours = Math.floor(minutes / 60)
    minutes %= 60
    const days = Math.floor(hours / 24)
    hours %= 24
    return {
      days: { max: 30, current: days },
      hours: { max: 24, current: hours },
      minutes: { max: 60, current: minutes },
      seconds: { max: 60, current: seconds },
    }
  }

  const charts = {}

  const showTimer = (timer) => {
    timer.classList.add("_show")
    timer.classList.remove("_preloader")
  }

  const hideTimer = (timer) => {
    timer.classList.remove("_show")
    timer.classList.add("_preloader")
  }

  const updateTimer = (timer, end) => {
    const chartsEl = timer.querySelectorAll("[data-timer-chart]")

    chartsEl.forEach((el) => {
      const type = el.dataset.timerChart
      const textEl = el.querySelector("[data-timer-text]")
      const update = () => {
        const currentTime = new Date()

        if (currentTime >= end) return
        const date = convertMS(Math.abs(end - currentTime))
        const time = date[type].current
        const max = date[type].max

        if (textEl.innerHTML !== time.toString()) {
          textEl.innerHTML = time
          charts[type].update(time / max * 100)
        }
      }
      setInterval(update, 1000)
    })
  }

  const startTimer = (timer, end) => {
    const chartsEl = timer.querySelectorAll("[data-timer-chart]")
    let isStarted = false
    const currentTime = new Date()
    if (currentTime >= end) return

    chartsEl.forEach((el) => {
      const size = el.offsetWidth
      const type = el.dataset.timerChart
      const date = convertMS(Math.abs(end - currentTime))
      const time = date[type].current
      const max = date[type].max
      const currentValue = time / max * 100

      /* global EasyPieChart */
      const chart = new EasyPieChart(el, {
        scaleColor: false,
        trackColor: "#DADADA",
        barColor: "#484bfc",
        lineWidth: 2,
        lineCap: "butt",
        size,
        onStop: () => {
          if (!isStarted) {
            $(document).trigger("timer:start")
            isStarted = true
          }
        },
      })

      charts[type] = chart

      setTimeout(() => {
        el.classList.remove("_preload")

        charts[type].update(currentValue)
        updateTimer(timer, end)
      }, 400)
    })
  }

  $(document).on("scroll:timer", () => {
    const timers = document.querySelectorAll("[data-js-timer]")
    const currentTime = new Date().getTime()

    timers.forEach((timer) => {
      const startTime = new Date(timer.dataset.start).getTime()
      const endTime = new Date(timer.dataset.end).getTime()

      if (currentTime > startTime && currentTime < endTime) {
        showTimer(timer)
        startTimer(timer, endTime)
      } else {
        hideTimer(timer)
      }

      const checkDuration = () => {
        const currentTime = new Date().getTime()

        if (currentTime > startTime && currentTime < endTime) {
          showTimer(timer)
        } else {
          hideTimer(timer)
        }
      }

      setInterval(checkDuration, 1000)
    })
  })
})



// WEBPACK FOOTER //
// ./src/blocks/hero/timer/timer.js